import styled from 'styled-components';

const BurgerMenuIconStyle = styled.div`
	--sizeBtnWidth: 18px;
	--sizeLineHeight: 3px;
	--distanceLine: 6px;

	width: var(--sizeBtnWidth);
	height: 21px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	cursor: pointer;
	z-index: 11;

	.menu-btn-1 {
		transition: var(--trTime) ease-in-out;
	}

	.menu-btn-1 span,
	.menu-btn-1 span::before,
	.menu-btn-1 span::after {
		content: '';
		position: absolute;
		width: var(--sizeBtnWidth);
		height: var(--sizeLineHeight);
		background-color: var(--red1000);

		-webkit-transition: var(--trTime) ease-in-out;
		-moz-transition: var(--trTime) ease-in-out;
		-o-transition: var(--trTime) ease-in-out;
		transition: var(--trTime) ease-in-out;
	}

	.menu-btn-1 span::before {
		margin-top: calc(var(--distanceLine) * -1);
	}

	.menu-btn-1 span::after {
		margin-top: var(--distanceLine);
	}

	.menu-btn-1.active {
		transform: translateX(calc((var(--sizeBtnWidth) - var(--sizeBtnWidth))));
	}

	.menu-btn-1.active span {
		background-color: transparent;
	}

	.menu-btn-1.active span::before {
		width: var(--sizeBtnWidth);
		background-color: var(--red1000);
		margin-top: 0;

		-webkit-transform: rotate(45deg);
		-moz-transform: rotate(45deg);
		-o-transform: rotate(45deg);
		transform: rotate(45deg);
	}

	.menu-btn-1.active span::after {
		width: var(--sizeBtnWidth);
		background-color: var(--red1000);
		margin-top: 0;

		-webkit-transform: rotate(-45deg);
		-moz-transform: rotate(-45deg);
		-o-transform: rotate(-45deg);
		transform: rotate(-45deg);
	}
`;

export default BurgerMenuIconStyle;
